/* eslint-disable */

/**
 * COMPONENT mega-menu
 *
 * Handles opening and closing of the menu and populates open menu with data from the server.
 */

var _each = require('lodash.foreach');
var Cookies = require('cookies-js');
var http = require('./http');
var lazyLoadedImages = require('./components/lazyLoadedImages');
var domutils = require('./domutils');
var makeElt = domutils.makeElt;



function appendChilds(parent, eltArray) {
  _each(eltArray, function(elt) { parent.appendChild(elt); });
}

function createSegment(segment, listElt) {
  var itemElt = makeElt('li');
  if ('not_clickable' == segment.targetType) {
    var linkElt = makeElt('span', {
      innerHTML: segment.label
    }, {'data-level': 3});
  } else {
    var linkElt = makeElt('a', {
      href: segment.link,
      innerHTML: segment.label
    }, {'data-level': 3});
  }
  itemElt.appendChild(linkElt);
  listElt.appendChild(itemElt);
  domutils.on(linkElt, 'click', setTagging, false);
}

function createCategory(cat, cb) {
  var catElt = makeElt('div', { className: 'menu-cat' });
  var listElt = makeElt('ul');
  var rootElt = null;

  var titleContentElt = makeElt('strong', {
    className: 'cat-name',
    innerHTML: cat.label
  });

  if(cat.targetType != 'not_clickable'){
    rootElt = makeElt('a', {href: cat.link }, {
      'data-level': 2
    });
    rootElt.appendChild(titleContentElt);
  } else {
    rootElt = titleContentElt;
  }


  cb(catElt, rootElt, listElt);
  domutils.on(rootElt, 'click', setTagging, false);
}

function setTagging(e) {
  var desktopNav = domutils.qid('desktop-nav');
  var parent = domutils.parentsByClass(this, 'menu');
  var dept = this;
  if (!domutils.attr(dept, 'data-rel')) {
    dept = domutils.q('a[data-rel="' + parent.id + '"]', desktopNav);
  }
  if (!dept) return;
  var contextData = {
    'nav_type': 'Mega menu',
    'nav_dept': dept.textContent.trim(),
    'nav_level': this.getAttribute('data-level'),
    'nav_name': this.textContent.trim(),
    'nav_list_products': 'No'
  };
  Cookies.set('s_contextData', JSON.stringify(contextData));
}

function createBanners(banners) {
  var bannersColElt = makeElt('div', {
    className: 'menu-clm menu-clm-banners'
  });
  _each(banners, function(banner) {
    var bannerElt = makeElt('a', {
      href: banner.link,
      title: banner.alt
    });
    var pictureElt = makeElt(
      'picture',
      {
        className: 'lozadImage',
        style: 'display: inline-block; width: 100%;'

      },
      {
        'data-alt': '',
        'data-iesrc': banner.src

      }
    );
    var sourceElt = makeElt('source', {}, { srcset: banner.src });
    pictureElt.appendChild(sourceElt);
    bannerElt.appendChild(pictureElt);
    bannersColElt.appendChild(bannerElt);
  });
  return bannersColElt;
}

function createFeatures(features) {
  var featuresColElt = makeElt('ul', { className: 'features' });
  _each(features, function(feature) {
    var featElt = makeElt('li');
    var featIcon = makeElt('img', { src: feature.src }, { alt: '' });
    var featText = makeElt('span', {
      innerHTML: feature.text
    });
    var featLink = makeElt('a', { href: feature.link });
    appendChilds(featLink, [featIcon, featText]);
    featElt.appendChild(featLink);
    featuresColElt.appendChild(featElt);
  });
  return featuresColElt;
}

function createMenus(elt, menus, cb) {
  var navElts = domutils.qall('a[data-rel]', elt);

  // Menus
  _each(menus, function(menu, i) {
    var containerElt = makeElt('div', { className: 'menu-container' });
    var menuElt = makeElt('div', { className: 'menu', id: 'univ-' + i });
    var cols = menu.nav;

    // Cols
    _each(cols, function(categories) {
      var colElt = makeElt('div', { className: 'menu-clm' });

      // Categories
      _each(categories, function(cat) {
        createCategory(cat, function(catElt, titleElt, listElt) {
          _each(cat.nav, function(segment) {
            createSegment(segment, listElt);
          });
          appendChilds(catElt, [titleElt, listElt]);
          colElt.appendChild(catElt);
        });
      });
      menuElt.appendChild(colElt);
    });

    var bannersColElt = createBanners(menu.banners);
    var featuresColElt = createFeatures(menu.features);
    appendChilds(menuElt, [bannersColElt, featuresColElt]);
    containerElt.appendChild(menuElt);
    domutils.attr(navElts[i], 'data-level', 1);
    domutils.on(navElts[i], 'click', setTagging, false);
    domutils.after(containerElt, navElts[i]);
  });

  lazyLoadedImages();
}

module.exports = function megaMenu(elt, url) {
  if (!elt) return;
  var timer = null;
  var timerOut = null;
  var loaded = false;
  var nav = domutils.q('.nav', elt);
  var innerNav = domutils.qall('.nav li', elt);
  var tabs = domutils.qall('a[data-rel]', nav);
  var current = null;
  var delay = 0;
  var homeButton = domutils.q('.nav li.home', elt);

  /**
   * Load menu data from server then pass it to createMenus for DOM rendering
   * This is called later on in this file
   *
   * @returns {*|Promise.<T>}
   */
  function attachMenus() {
    nav.className = nav.className + ' nav-loading';
    return http.get(url, {}, { outputType: 'json' }).then(function(res) {
      nav.className.replace(' nav-loading', '');
      loaded = true;
      createMenus(elt, res.body);
    }, function(err) {
      console.log('Mega menu failed to load:', err);
    });
  }

  function displayTab(tab) {
    var parentEl = tab.parentElement;
    var menuEl = domutils.q('.menu-container', parentEl);
    var menuEls = domutils.qall('.menu-container', nav);
    _each(menuEls, function(menu) {
      menu.style.display = (menu === menuEl)? 'block' : 'none';
    });
    current = menuEl;
  }

  function currentMenuTab(tab) {
    var parentEl = tab.parentElement;
    var menuEl;
    return menuEl = domutils.q('.menu-container', parentEl);
  }

  domutils.on(nav, 'mouseenter', function(e) {
    //$('.currentMenu').removeClass('currentMenu');
  });

  attachMenus().then(function() {
    nav.className = 'nav';
    document.addEventListener('transitionend', function(e) {
      if ($('.currentMenu')) {
        if ($('.currentMenu').height() > 0) {
          $('.menu-container').css({transition:'max-height 0s ease-out 0s'});
        } else {
          $('.menu-container').css({transition: 'max-height 0.2s ease-out 0.3s'});
        }
      }
    });
    _each(tabs,function(tab){
      domutils.on(tab,'mouseenter',function(){
        var thisMc = currentMenuTab(tab);
        $('.currentMenu').removeClass('currentMenu');
        $(thisMc).addClass('currentMenu');
      });
      domutils.on(tab,'mouseleave',function(){
        if (!$('.currentMenu')) {
          $('.menu-container').css({transition: 'max-height 0.2s ease-out 0.3s'});
        }
      })
    });
  });
  domutils.on(nav, 'mouseleave', function(e) {
    if (timer) clearTimeout(timer);

    $('.menu-container').css({transition: 'max-height 0.2s ease-out 0.3s'});
    $('.currentMenu').removeClass('currentMenu');
  });
  domutils.on(homeButton, 'mouseenter', function(e) {
    $('.currentMenu').removeClass('currentMenu');
    $('.menu-container').css({transition: 'max-height 0.2s ease-out 0.3s'});
  });
};
